var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_automation)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12109 7.31982C6.12109 6.21525 7.01652 5.31982 8.12109 5.31982H10.1211C11.2257 5.31982 12.1211 6.21525 12.1211 7.31982V9.31982C12.1211 10.4244 11.2257 11.3198 10.1211 11.3198H8.12109C7.01652 11.3198 6.12109 10.4244 6.12109 9.31982V7.31982Z",
    stroke: "#7F8594",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 15.3198C14.1211 14.2153 15.0165 13.3198 16.1211 13.3198H18.1211C19.2257 13.3198 20.1211 14.2153 20.1211 15.3198V17.3198C20.1211 18.4244 19.2257 19.3198 18.1211 19.3198H16.1211C15.0165 19.3198 14.1211 18.4244 14.1211 17.3198V15.3198Z",
    stroke: "#7F8594",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 8.31982H14.1211C15.7779 8.31982 17.1211 9.66297 17.1211 11.3198V13.3198",
    stroke: "#7F8594",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.62109,
    cy: 16.3198,
    r: 2,
    stroke: "#7F8594",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12109 11.3198V14.3198C8.12109 15.4244 7.22566 16.3198 6.12109 16.3198H6.62109",
    stroke: "#7F8594",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_automation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.121094 0.319824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationIcon);
export default __webpack_public_path__ + "static/media/automation-icon.35bedba911143736797ca7bba1c69812.svg";
export { ForwardRef as ReactComponent };